import moment from 'moment'

import DatesWFFMDataExchange from '@/services/DatesWFFMDataExchange'

export default {
  data () {
    return {
      dx: { dates: new DatesWFFMDataExchange(this.form) },
      editedDates: null,
      dates: {
        mode: 'start',
        selected: moment.range(moment(), moment().add('years', 2)),
        validDates: moment.range(moment(), moment().add('years', 2)),
      },
    }
  },

  computed: {
    selectedDateLabel () {
      return 'Wylot od - Przylot do'
    },

    selectedDateStartValue () {
      const dates = this.dropdowns.dates ? this.editedDates : this.dates.selected
      if (this.dates.mode == 'month') {
        const formattedName = moment(dates.start).format('MMMM')
        const formattedYear = moment(dates.start).year()
        return `${formattedName} ${formattedYear}`
      } else if (this.datesInitialState(dates.start, dates.end)) {
        return `od ${dates.start.format('dd DD.MM.YYYY')}`
      } else {
        return `${dates.start.format('dd DD.MM.YY')} -`
      }
    },

    selectedDateEndValue () {
      const dates = this.dropdowns.dates ? this.editedDates : this.dates.selected
      if (this.dates.mode === 'end' && dates.end.isZero()) {
        return this.dates.selected.end.format('dd DD.MM.YY')
      } else if (!this.datesInitialState(dates.start, dates.end) && this.dates.mode !== 'month') {
        return this.invalidEndDateFallback(dates)
      } else if (this.dates.validDates.end.isSame(dates.end, 'day') || dates.end.isZero()) {
        return ''
      } else if (this.dates.mode === 'month') {
        return ''
      } else {
        return dates.end.format('dd DD.MM.YY')
      }
    },
  },

  created () {
    this.dates.selected = this.dx.dates.data
  },

  methods: {
    startEditDates (mode) {
      if (this.dropdowns.dates) {
        if (this.dates.mode !== 'month') {
          this.dates.mode = mode
        }
      } else {
        this.editedDates = moment.range(this.dates.selected.start, this.dates.selected.end)
        this.setDatesMode(mode)
        this.toggle('dates')
      }
    },

    endEditDates () {
      if (this.dates.mode === 'end') {
        // Prevents unnecessary Ajax request caused only by calendar mode change
        this.dates.mode = 'start'
      }
      this.toggle('dates')
      this.updateAvailableValues()
    },

    setDatesMode (mode) {
      if (this.dates.mode === 'date') this.dates.mode = 'date'
      else if (this.dates.mode === 'month') this.dates.mode = 'month'
      else this.dates.mode = mode
    },

    updateEditedDates (start, end) {
      this.editedDates = moment.range(start, end)
    },

    datesInitialState (start, end) {
      return this.dates.validDates.start.isSame(start, 'day') && this.dates.validDates.end.isSame(end, 'day')
    },

    invalidEndDateFallback (dates) {
      if (this.dates.validDates.contains(dates.end)) {
        return dates.end.format('dd DD.MM.YY')
      } else {
        return this.dates.validDates.end.format('dd DD.MM.YY')
      }
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/search/logic/DatesDesktop.js